import {BaseService} from './Core/BaseService';

class SurveyAnswerService extends BaseService {
    get Url() { return super.Url + "/surveyAnswers"; }

    GetSurveyAnswers(surveyTypeId, conservationActionId) {
        let request = {
            surveyTypeId: surveyTypeId,
            conservationActionId: conservationActionId
        };

        return this.SendRequest(BaseService.GET, request);
    }

    CopySurveyAnswers(conservationActionId, surveyTypeId, targetConservationActionId, targetSurveyId ) {
        let request = {
            conservationActionId: conservationActionId,
            surveyTypeId: surveyTypeId,
            targetSurveyId: targetSurveyId,
            targetConservationActionId: targetConservationActionId
        };

        return this.SendRequest(BaseService.GET, request, null, '/copy');
    }

    UpdateSurveyAnswers(answers, quantities, risks, surveyId, conservationActionId, conservationActionSampleEvents = null, conservationActionPermits = null, loadedSurveyAnswerIds = null) {
        let request = {
            surveyId: surveyId,
            conservationActionId: conservationActionId,
            answers: answers,
            SurveyAnswerPlantQuantityZone: quantities,
            risks: risks,
            ConservationActionSampleEvents: conservationActionSampleEvents,
            ConservationActionPermits: conservationActionPermits,
            // The active surveyAnswerIds this form loaded; the server rejects
            // the save (409) if an answer it would overwrite changed after that load.
            // Omitted (null) = skip the check, preserving last-write-wins for callers
            // that don't round-trip a snapshot.
            loadedSurveyAnswerIds: loadedSurveyAnswerIds,
        };

        return this.SendRequest(BaseService.PUT, request);
    }
}

export const service = new SurveyAnswerService();

